import type { JournalLoreData } from "@roll1/shared";
import { Input } from "../ui/input";
import { MarkdownEditor } from "../ui/markdown-editor";
import { Label } from "../ui/label";
import { useI18n } from "../../i18n";

interface LoreFormProps {
  data: JournalLoreData;
  onChange: (partial: Partial<JournalLoreData>) => void;
  focusedFieldRef: React.MutableRefObject<string | null>;
}

/**
 * A lore record / a note (Q-3): «Видят игроки» (content — what the players get when it is shown) and «Для мастера»
 * (gmNotes — never in a copy for a player); the category stays below.
 */
export default function LoreForm({
  data,
  onChange,
  focusedFieldRef,
}: LoreFormProps) {
  const { t } = useI18n();

  const handleFocus = (field: string) => {
    focusedFieldRef.current = field;
  };
  const handleBlur = () => {
    focusedFieldRef.current = null;
  };

  return (
    <div className="space-y-3">
      <div>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.lore.content")}
        </Label>
        <MarkdownEditor
          className="text-ui min-h-[120px]"
          aria-label={t("journal.form.lore.content")}
          value={data.content}
          onValueChange={content => onChange({ content })}
          onFocus={() => handleFocus("content")}
          onBlur={handleBlur}
        />
      </div>
      <div>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.lore.gmNotes")}
        </Label>
        <MarkdownEditor
          className="text-ui min-h-[80px]"
          aria-label={t("journal.form.lore.gmNotes")}
          value={data.gmNotes ?? ""}
          onValueChange={gmNotes => onChange({ gmNotes })}
          onFocus={() => handleFocus("gmNotes")}
          onBlur={handleBlur}
        />
      </div>
      <div>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.lore.category")}
        </Label>
        <Input
          className="h-8 text-ui"
          value={data.category}
          onChange={(e) => onChange({ category: e.target.value })}
          onFocus={() => handleFocus("category")}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
}
